import * as React from "react";
import {ReactElement} from "react";
import {Box, Button, Toolbar} from "@mui/material";
import styled from "styled-components";
import LanguageSelect from "../select/LanguageSelect";
import ThemeSwitch from "../switch/ThemeSwitch";
import {routes} from "../../routing/Routes";
import useRedirect from "../../routing/useRedirect";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const StyledToolbar = styled(Toolbar)(({theme}) => ({
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.only('xs')]: {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    },
    justifyContent: 'space-between',
}));
const Col = styled(Box)(({theme}) => ({
    display: 'flex',
    [theme.breakpoints.only('xs')]: {
        gap: 0,
    },
    [theme.breakpoints.up('sm')]: {
        gap: theme.spacing(2),
    },
}));

interface IProps {
}

function NavBar(props: IProps): ReactElement {
    const redirect = useRedirect();

    return (
        <StyledToolbar id={'Toolbar'}>
            <Col sx={{flexShrink: 0,}}>
                <Button
                    aria-label="Home"
                    onClick={() => redirect(routes.index)}
                    sx={{
                        minWidth: 'auto',
                    }}
                >
                    <HomeRoundedIcon sx={{color: 'white', width: 36, height: 36,}}/>
                </Button>
            </Col>

            <Col>
                <LanguageSelect/>
                <ThemeSwitch/>
            </Col>
        </StyledToolbar>
    );
}

export default NavBar;
